import { useMatch } from "react-router-dom";

export const useRouteTopLevelReference = (): {
  organizationSlug?: string;
  serverId?: string;
  databaseId?: string;
  serverGroupId?: string;
} => {
  const databaseMatch = useMatch(`/databases/:databaseId/*`);
  const serverMatch = useMatch(`/servers/:serverId/*`);
  const serverGroupMatch = useMatch(`/servergroups/:serverGroupId/*`);
  const organizationMatch = useMatch(`/organizations/:slug/*`);
  if (databaseMatch) {
    return { databaseId: databaseMatch.params["databaseId"] };
  }
  if (serverMatch) {
    return { serverId: serverMatch.params["serverId"] };
  }
  if (serverGroupMatch) {
    return { serverGroupId: serverGroupMatch.params["serverGroupId"] };
  }
  if (organizationMatch) {
    const organizationSlug =
      (organizationMatch.params["slug"] !== "new" &&
        organizationMatch.params["slug"]) ||
      undefined;
    return { organizationSlug };
  }
  return {};
};
